export default __webpack_public_path__ + "static/media/07c94cb4cdfe4b43f95090cece1b7931.svg";